import React from 'react'

type Props = {
  label: string,
  value: boolean,
  onChange: (boolean) => void,
  isDisabled?: any,
}

export const RawToggleButton = (props: Props) =>
  <div className="form-group">
    <label>{props.label}
      <input id="auto_monitoring_toggle"
        type="checkbox"
        defaultChecked={props.defaultChecked}
        checked={props.checked}
        onChange={(e) => props.onChange(e.currentTarget.checked)}
        disabled={props.isDisabled}
      />
    </label>
  </div>

export default RawToggleButton



// WEBPACK FOOTER //
// ./src/controls/toggle-button.js